import { CenteredSpinner } from "@/lib/components/CenteredSpinner";

export function ProfileLoading() {
  return (
    <div className="py-12">
      <CenteredSpinner />
      <p className="text-center text-muted-foreground mt-4">Loading profile information...</p>
    </div>
  );
}
